export default {
	getModelDirective: getModelDirective,

	getModelName: getModelName,

	isModelHasLazy: isModelHasLazy,

	format: format,

	float: float,

	int: int,

	ceilByStep: ceilByStep,

	floorByStep: floorByStep,

	roundByStep: roundByStep,
}

/** @deprecated */
function getModelDirective(vnode) {
	var modelDirective;
	modelDirective = vnode.dirs
		.filter(function (dir) {
			return dir.name === 'model';
		})[0]
	;
	if (modelDirective == null) {
		return null;
	}
	return modelDirective;
}

/** @deprecated */
function getModelName(vnode) {
	var modelDirective = getModelDirective(vnode);
	if (modelDirective == null || !('expression' in modelDirective)) {
		return null;
	}
	if (!(modelDirective.expression in vnode.context)) {
		return null;
	}
	return modelDirective.expression;
}

function isModelHasLazy(vnode) {
	var modelDirective = getModelDirective(vnode);
	if (modelDirective == null || !('modifiers' in modelDirective)) {
		return null;
	}
	if ('lazy' in modelDirective.modifiers && modelDirective.modifiers.lazy === true) {
		return true;
	}
	return false;
}

function format(value) {
	if (value == null) {
		return '';
	}
	value = value.toString();
	value = value.replace(',', '.');
	value = value.replace(/[^\d.]/g, '');
	if (value.substr(value.length - 1, 1) === '.') {
		value = value.substr(0, value.length - 1);
	}
	return value;
}

function float(value) {
	value = parseFloat(value);
	if (isNaN(value)) {
		value = 0;
	}
	return value;
}

function int(value) {
	value = parseInt(value);
	if (isNaN(value)) {
		value = 0;
	}
	return value;
}

function ceilByStep(value, step) {
	if (value % step === 0) {
		return value;
	}
	return value - value % step + step;
}

function floorByStep(value, step) {
	if (value % step === 0) {
		return value;
	}
	return value - value % step;
}

function roundByStep(value, step) {
	var ceilResult = ceilByStep(value, step),
		floorResult = floorByStep(value, step);
	if (ceilResult - value < value - floorResult) {
		return ceilResult;
	} else {
		return floorResult;
	}
}
